import React, { useState, useEffect } from "react";
import { CreateUser } from "@hedgefund/shared";
import { createUser, getRoles } from "./actions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { alertService } from "@hedgefund/shared/src/Alert/index";

const CreateNewUser = () => {
  const [message, setMessage] = useState();
  const createUserState = useSelector((state) => state.createNewUsers);
  const history = useHistory();
  const dispatch = useDispatch();
  const { loading, roles } = createUserState;

  useEffect(() => {
    dispatch(getRoles());
  }, [dispatch]);

  const onSuccess = () => {
    alertService.success("User Created Successfully", { autoClose: true });

    setTimeout(() => {
      history.push("/management");
    }, 1000);
  };

  const onSubmit = (value) => {
    dispatch(createUser(value, onSuccess));
  };

  return (
    <CreateUser
      onSubmit={onSubmit}
      loading={loading}
      message={message}
      roles={roles}
    />
  );
};

export default CreateNewUser;
